import { useEffect, useState } from 'react';

// Module-level state — survives re-renders, shared across the whole app
let listeners = [];
let isLoading = false;

export function setGlobalLoading(loading) {
  isLoading = loading;
  listeners.forEach(fn => fn(loading));
}

export function useGlobalLoading() {
  const [loading, setLoading] = useState(isLoading);
  useEffect(() => {
    listeners.push(setLoading);
    return () => { listeners = listeners.filter(fn => fn !== setLoading); };
  }, []);
  return loading;
}

export default function ProgressBar() {
  const loading = useGlobalLoading();
  const [width, setWidth] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (loading) {
      setVisible(true);
      setWidth(0);
      const t1 = setTimeout(() => setWidth(30), 50);
      const t2 = setTimeout(() => setWidth(60), 300);
      const t3 = setTimeout(() => setWidth(80), 800);
      return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
    } else {
      setWidth(100);
      const t = setTimeout(() => {
        setVisible(false);
        setWidth(0);
      }, 400);
      return () => clearTimeout(t);
    }
  }, [loading]);

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      height: '3px',
      zIndex: 99999,
      background: 'transparent',
      pointerEvents: 'none',
    }}>
      <div style={{
        height: '100%',
        width: `${width}%`,
        background: 'linear-gradient(90deg, #f59e0b, #fbbf24)',
        transition: width === 100 ? 'width 0.2s ease' : 'width 0.6s ease',
        boxShadow: '0 0 8px rgba(245,158,11,0.6)',
      }} />
    </div>
  );
}
